import isEmail from "validator/lib/isEmail";
import {validateMaxLength} from '../../common/validationUtils';
import {messages} from '../common/Translations';
import {plainJSTranslator} from "../../common/PlainJSTranslator";

export const companyValidation = (values, props) => {
    let errors = {};
    //@TODO Get from server
    const DEFAULT_CATEGORY_COUNT = 3;

    const requiredFields = [
        'keywords',
        'name',
        'recruiterId',
        'addressId',
        'city',
    ];

    requiredFields.forEach(function (requiredField) {
        if (!values[requiredField]) {
            errors[requiredField] = plainJSTranslator.formatMessage(messages.required);
        }
    });

    if(!values.description.replace(/\s|&nbsp;|(<([^>]+)>)/g, '')) {
        errors.description = plainJSTranslator.formatMessage(messages.required);
    }

    /*if(DEFAULT_CATEGORY_COUNT < values.categoryIds.length) {
        errors.categoryIds = plainJSTranslator.formatMessage(messages.enterCategoryToSave);
    }

    if(values.categoryIds.length === 0 && props.isAdmin) {
        errors.categoryIds = plainJSTranslator.formatMessage(messages.errorSelectCategories);
    }*/

    //// Company information



    if(!values.postalCode || values.postalCode.length !== 4) {
        errors.postalCode = plainJSTranslator.formatMessage(messages.mustBe4Digits);
    }

    if(values.cvr && values.cvr.length !== 8) {
        errors.cvr = plainJSTranslator.formatMessage(messages.mustBe8Digits);
    }

    if(values.pNumber && values.pNumber.length !== 10) {
        errors.pNumber = plainJSTranslator.formatMessage(messages.mustBe10Digits);
    }

    if(values.phoneNumber && !isValidPhone(values.phoneNumber)) {
        errors.phoneNumber = plainJSTranslator.formatMessage(messages.invalidPhone);
    }

    if(values.faxNumber && !isValidPhone(values.faxNumber)) {
        errors.faxNumber = plainJSTranslator.formatMessage(messages.invalidFax);
    }

    if(values.email && !isEmail(values.email)) {
        errors.email = plainJSTranslator.formatMessage(messages.invalidEmail);
    }

    [
        'homepage',
        'facebook',
        'linkedin',
        'twitter',
        'instagram',
    ].forEach(function (urlFieldName) {
        if(values[urlFieldName] && !isValidUrl(values[urlFieldName])) {
            errors[urlFieldName] = plainJSTranslator.formatMessage(messages.mustStartWithHTTP);
        }
    });

    errors = validateMaxLength({values, errors, length: 255, fields: [
        'name',
        'keywords',
        'city',
        'email',
        'homepage',
        'facebook',
        'linkedin',
        'twitter',
        'instagram',
        'employeeCount',
    ]});

    return errors;
};


function isValidPhone(value) {
    return value.toString().length === 8 && /^\d+$/.test(value.toString());
}

function isValidUrl(value) {
    return value.match(/^https?:\/\//);
}


// WEBPACK FOOTER //
// ./web/src/components/company/companyValidation.js